<template>
    <div class="conter">
        <div class="title">AI-LiNK智慧集成产品需求</div>
        <div class="currency_suggest" v-if="bShowText">
            <div class="titel_al">
                <div class="title_can">AI-LiNK智慧集成产品需求</div>
            </div>
            <div class="personnel">
                <div
                    class="personnel_conter"
                    v-for="(item, index) in reporInfo.tags"
                    v-show="item.type == 3"
                    :key="index"
                >
                    <div class="per_laber">
                        <span :class="['btn_laber', item.nameClass]">{{
                            item.name
                        }}</span>
                        <span
                            class="eait"
                            v-if="!reporInfo.bShowCard"
                            @click="
                                getEait(
                                    item.strDeasAilink,
                                    item.type,
                                    index,
                                    item.tag_ailink_id
                                )
                            "
                        ></span>
                    </div>
                    <div class="per_textar" v-html="item.strDeasAilink"></div>
                </div>
                <div class="personnel_conter">
                    <div class="per_laber">
                        <span :class="['btn_laber', 'five_icon']"
                            >其他需求</span
                        >
                        <span
                            class="eait"
                            v-if="!reporInfo.bShowCard"
                            @click="
                                getEaitOther(
                                    reporInfo.mark_extra == '' ? '' : reporInfo.mark_extra
                                )
                            "
                        ></span>
                    </div>
                    <div class="per_textar" v-if="reporInfo.mark_extra != ''">
                        <div
                            class="textea"
                            :style="{
                                height: reporInfo.mark_extra != '' ? 'auto' : '',
                            }"
                            v-html="
                                reporInfo.mark_extra == ''
                                    ? '根据需求填写描述，若无增加可选填'
                                    : reporInfo.mark_extra
                            "
                        ></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="currency_suggest" v-if="reporInfo.arrDeaAilink.length">
            <div class="titel">
                <span>产品选型</span>
            </div>
            <div>
                <div
                    class="lytab_sub"
                    v-for="(item, index) in reporInfo.arrAliinkSub"
                    :key="index"
                >
                    <div class="lytab" v-if="reporInfo.arrAliinkSub.length > 1">
                        <div class="lytab_list" style="width: 100%">
                            <div class="arrRooms">
                                <div
                                    class="actRoomNav roomNav"
                                    style="width: 100%"
                                >
                                    {{ item.room | roomNumber }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="shopp_conter">
                        <div
                            class="shopp_list"
                            v-for="(items, indexs) in item.arrAilink"
                            @click="getDetails(items.product_id)"
                            :key="indexs"
                        >
                            <div class="shopp_img">
                                <img v-lazy="items.mobile_img" alt="" />
                            </div>
                            <div class="shopp_text">
                                <div>{{ items.new_goods_type_name }}</div>
                                <div class="text_item">
                                    {{ items.goods_name }}
                                </div>
                                <div>
                                    <div
                                        class="situat_item"
                                        v-for="(
                                            attritem, attrindex
                                        ) in items.attr_two"
                                        :key="attrindex"
                                    >
                                        <span class="label">{{
                                            attritem.attr_name
                                        }}</span>
                                        <span class="room_type">{{
                                            attritem.attr_value
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="lytab" v-if="reporInfo.arrAliinkSub.length > 1">
        <div
          class="lytab_list"
          :style="{ width: reporInfo.arrAliinkSub.length < 5 ? '100%' : '' }"
        >
          <div class="arrRooms">
            <div
              :class="[
                nRoomIndex == index ? 'actRoomNav' : '',
                reporInfo.arrAliinkSub.length < 5 ? 'roomNav' : 'xRoomNav',
              ]"
              :style="{
                width:
                  reporInfo.arrAliinkSub.length < 5
                    ? 100 / reporInfo.arrAliinkSub.length + '%'
                    : '',
              }"
              v-for="(item, index) in reporInfo.arrAliinkSub"
              :key="index"
              @click="getRoom(index)"
            >
              {{ item.room | roomNumber }}
            </div>
          </div>
          <div :class="['second_nav_strip']">
            <div
              :class="[reporInfo.arrAliinkSub.length < 5 ? 'strip' : 'nostrips']"
              :style="{
                left: (100 / reporInfo.arrAliinkSub.length) * nRoomIndex + '%',
                width:
                  reporInfo.arrAliinkSub.length < 5
                    ? 100 / reporInfo.arrAliinkSub.length + '%'
                    : '',
              }"
            ></div>
          </div>
        </div>
      </div> -->
        </div>
        <textInput
            :bShowIput.sync="bShowIput"
            :sText.sync="sText"
            :nType.sync="nType"
            :nIndex.sync="nIndex"
            :tagId.sync="tagId"
            :category.sync="category"
            @sumbit="sumbitzi"
        ></textInput>
    </div>
</template>
<script>
import textInput from "../../components/textinput/index";
export default {
    components: {
        textInput,
    },
    props: {
        bShowText: {
            type: Boolean,
            default: false,
        },
        reporInfo: {
            type: Object,
            default: false,
        },
    },
    data() {
        return {
            nRoomIndex: 0,
            category: 3,
            tagId: 0,
            bShowIput: false,
            nType: 0, //类型
            sText: "", //需要修改的文本
            nIndex: 0,
        };
    },
    filters: {
        roomNumber(index) {
            // console.log("-->计算属性", index);
            let arr = [
                "一",
                "二",
                "三",
                "四",
                "五",
                "六",
                "七",
                "八",
                "九",
                "十",
            ];
            if (index < 0) {
                return "地下室" + arr[Number(-index) - 1] + "层";
            } else if (index <= 10 && index > 0) {
                return arr[Number(index) - 1] + "层";
            }
        },
    },
    methods: {
        getEaitOther(otherText) {
            this.nType = -1;
            this.sText = otherText.replace(/<br\/>/g, "\r\n");
            this.bShowIput = true;
        },
        getRoom(index) {
            this.nRoomIndex = index;
            this.$emit("getRoom", index);
        },
        //查看商品详情
        getDetails(id) {
            this.$router.push({ path: `/shopp/details?id=${id}` });
        },
        sumbitzi(e) {
            // console.log("sumbit", e);
            this.$emit("sumbitzi", e);
        },
        //点击编辑文本
        getEait(html_deas, type, index, tag_ailink_id) {
            this.nIndex = Number(index);
            // console.log(this.nIndex, index);
            (this.tagId = tag_ailink_id), (this.nType = type);
            this.sText = html_deas.replace(/<br\/>/g, "\r\n");
            this.bShowIput = true;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>